import "./simple_hero.scss";
